export default __webpack_public_path__ + "static/media/cocoron.f3672519.jpeg";